import script from "./Utilize.vue?vue&type=script&setup=true&lang=ts"
export * from "./Utilize.vue?vue&type=script&setup=true&lang=ts"

import "./Utilize.vue?vue&type=style&index=0&id=362b84a2&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362b84a2"]])

export default __exports__